import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography, Grid, Paper, Chip, Button } from "@material-ui/core";
import { iaWelcomeStyles } from "../../assets/styles/jss/pages/ia/IAWelcomeStyles";
import useRecentAgents from "../../utils/useRecentAgents";
import AGENTS from "../../utils/agents";

function formatRelativeTime(timestamp) {
    const diff = Date.now() - timestamp;
    const minutes = Math.floor(diff / 60000);
    if (minutes < 1) return 'Hace un momento';
    if (minutes < 60) return `Hace ${minutes} min`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `Hace ${hours}h`;
    const days = Math.floor(hours / 24);
    return `Hace ${days}d`;
}

export default function IAWelcome() {
    const classes = iaWelcomeStyles();
    const history = useHistory();
    const { recentAgents } = useRecentAgents();

    const handleNavigate = (path) => {
        history.push(path);
    };

    return (
        <Box className={classes.root}>
            {/* Hero Section */}
            <Box className={classes.heroSection}>
                <div className={classes.heroDecoration} />
                <Box className={classes.heroContent}>
                    <Typography variant="h3" className={classes.title}>
                        Talisis <span className={classes.titleAccent}>IA</span>
                    </Typography>
                    <Typography className={classes.subtitle}>
                        Bienvenido al centro de inteligencia artificial de Talisis.
                        <br />
                        Aquí encontrarás agentes especializados que te ayudarán a{' '}
                        <span className={classes.subtitleBold}>automatizar y optimizar</span>{' '}
                        procesos clave de tu operación.
                    </Typography>
                </Box>
            </Box>

            {/* Recently Used Section */}
            {recentAgents.length > 0 && (
                <Box>
                    <Box className={classes.sectionHeader}>
                        <Typography className={classes.sectionTitle}>
                            Usados recientemente
                        </Typography>
                        <div className={classes.sectionDivider} />
                    </Box>

                    <Grid container spacing={3}>
                        {recentAgents.map((agent) => (
                            <Grid item xs={12} sm={6} md={4} key={agent.id}>
                                <Paper
                                    className={classes.card}
                                    elevation={0}
                                    onClick={() => handleNavigate(agent.path)}
                                >
                                    <div className={classes.cardDecoration} />
                                    <Box className={classes.cardHeader}>
                                        <Box className={classes.iconContainer}>
                                            <i className={agent.icon} />
                                        </Box>
                                        <Box className={classes.cardTitleGroup}>
                                            <Typography className={classes.cardTitle}>
                                                {agent.label} Agent
                                            </Typography>
                                            <Chip
                                                label="Activo"
                                                size="small"
                                                className={classes.badge}
                                            />
                                        </Box>
                                    </Box>
                                    <Typography className={classes.cardDescription}>
                                        {agent.description}
                                    </Typography>
                                    <Box className={classes.cardFooter}>
                                        <Typography className={classes.lastUsedText}>
                                            <i className="ri-time-line" />
                                            {formatRelativeTime(agent.lastUsed)}
                                        </Typography>
                                        <Button
                                            className={classes.openButton}
                                            disableRipple
                                        >
                                            Abrir <i className="ri-arrow-right-s-line" />
                                        </Button>
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}

            {/* Available agents when no recent */}
            {recentAgents.length === 0 && (
                <Box>
                    <Box className={classes.sectionHeader}>
                        <Typography className={classes.sectionTitle}>
                            Agentes disponibles
                        </Typography>
                        <div className={classes.sectionDivider} />
                    </Box>

                    <Grid container spacing={3}>
                        {AGENTS.map((agent) => (
                            <Grid item xs={12} sm={6} md={4} key={agent.id}>
                                <Paper
                                    className={classes.card}
                                    elevation={0}
                                    onClick={() => handleNavigate(agent.path)}
                                >
                                    <div className={classes.cardDecoration} />
                                    <Box className={classes.cardHeader}>
                                        <Box className={classes.iconContainer}>
                                            <i className={agent.icon} />
                                        </Box>
                                        <Box className={classes.cardTitleGroup}>
                                            <Typography className={classes.cardTitle}>
                                                {agent.label} Agent
                                            </Typography>
                                            <Chip
                                                label="Activo"
                                                size="small"
                                                className={classes.badge}
                                            />
                                        </Box>
                                    </Box>
                                    <Typography className={classes.cardDescription}>
                                        {agent.description}
                                    </Typography>
                                    <Box className={classes.cardFooter}>
                                        <span />
                                        <Button
                                            className={classes.openButton}
                                            disableRipple
                                        >
                                            Abrir <i className="ri-arrow-right-s-line" />
                                        </Button>
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
        </Box>
    );
}
